import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import { Col, Row, Table } from 'antd';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useState } from 'react';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import Button from 'components/Button';
import { useHistory, useLocation } from 'react-router-dom';
import { DownloadIcon, UploadIcon } from 'assets/svg';
import { PlusOutlined } from '@ant-design/icons';
import AllocateApi from 'apis/Allocate';
import { useMutation } from 'react-query';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import { HocChangePagination } from 'utils/HocChangePagination';

type FixedType = 'left' | 'right' | boolean;

interface IProps {
  cap_shop_id: number;
}

export default function PlantAllocateTab3(props: IProps) {
  const { cap_shop_id } = props;
  const history = useHistory();
  const queryParam = useQueryParam();
  const { state } = useLocation<{
    page: number;
    page_size: number;
  }>();

  // const page = state?.page || 1;
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const [capitalProduct, setCapitalProduct] = useState<any[]>([]);
  const [total, setTotal] = useState<number>(0);

  const { mutate: getCapitalProduct, isLoading: isProductLoading } =
    useMutation(
      () => AllocateApi.getCapitalProduct(cap_shop_id, { page, page_size }),
      {
        onSuccess: (response: any) => {
          console.log('response');
          if (response.status === STATUS.SUCCESS) {
            setCapitalProduct(response.data.data);
            setTotal(response.data.total);
          }
        },
        onError: (error: any) => {
          if (error.response.data.status === 401) {
            handleError401();
          }
        },
      }
    );

  useEffect(() => {
    getCapitalProduct();
  }, [page, page_size]);

  const productLineColumn: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Nhãn hàng',
      dataIndex: 'nhan_hang',
      width: 120,
    },
    {
      title: 'Ngành hàng',
      dataIndex: 'nganh_hang',
      width: 120,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 120,
    },
    {
      title: 'Dòng hàng Xman',
      dataIndex: 'dong_hang',
      width: 180,
    },
    {
      title: 'Tỉ trọng Min (%)',
      dataIndex: 'ratio_min',
      width: 180,
    },
    {
      title: 'Tỉ trọng Max (%)',
      dataIndex: 'ratio_max',
      width: 180,
    },
    {
      fixed: 'right',
      width: 1,
    },
  ];

  return (
    <Content className="main-content">
      {/* <Row gutter={16} justify="end">
        <Col>
          <Button
            onClick={() => {
              history.push(
                `/plants-allocate/createAllocateGoods/${cap_shop_id}`
              );
            }}
            customClass="items-center"
          >
            {' '}
            <PlusOutlined /> Thêm dòng hàng
          </Button>
        </Col>
      </Row> */}

      <Table
        rowKey={(record) => record.id}
        className="customTable"
        size="small"
        columns={productLineColumn}
        dataSource={capitalProduct}
        scroll={{ x: 970 }}
        loading={isProductLoading}
        pagination={{
          className: 'flex items-center',
          current: page,
          pageSize: page_size,
          total: total,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          onChange: (page: number, page_size: number) => {
            history.push(`/approve-detail`, {
              page: page,
              page_size: page_size,
            });
          },
        }}
      />
    </Content>
  );
}
